import clsx from "clsx";
export function Medal({rank}: { rank: number }) {
    return (
        <div className="h-fit w-fit">
            <div
                className={clsx(
                    "absolute top-1/2 -translate-y-1/2 md:-translate-y-3/4 md:top-0 xl:translate-y-0 translate-x-1/2 right-0 md:right-1/2 md:translate-x-1/2 xl:translate-x-0 xl:right-0 z-30 size-[80px] md:size-[100px] rounded-full border-[12px] overflow-hidden flex items-center justify-center",
                    {"border-[#EFD474]": rank === 1},
                    {"border-[#DCD2D3]": rank === 2},
                    {"border-[#FFB36C]": rank === 3},
                )}>
                <div className="absolute inset-0 bg-white"/>
                <div className={clsx("absolute inset-0",
                    {"bg-[#EFD47433]": rank === 1},
                    {"bg-[#F8F1F2]": rank === 2},
                    {"bg-[#FFB36C33]": rank === 3})}/>
                <p className="relative z-10 !mb-0 text-3xl xl:text-5xl ">{rank}</p>
            </div>
        </div>
    )
}